import { Box } from '@factorialco/deprecated-design-system'

import { GridItemSkeleton } from './GridItem'

export function Skeleton() {
  return (
    <Box paddingLeft="s48" paddingBottom="s32">
      <Box flexDirection="row">
        <GridItemSkeleton position="7" />
        <GridItemSkeleton position="8" />
        <GridItemSkeleton position="9" />
      </Box>
      <Box flexDirection="row">
        <GridItemSkeleton position="4" />
        <GridItemSkeleton position="5" />
        <GridItemSkeleton position="6" />
      </Box>
      <Box flexDirection="row">
        <GridItemSkeleton position="1" />
        <GridItemSkeleton position="2" />
        <GridItemSkeleton position="3" />
      </Box>
    </Box>
  )
}
